module.exports = __webpack_public_path__ + "files/fb42af149d17f726c360ffa50c72bd0d.png";